import classnames from "classnames";
import { FileUpload } from "neetoicons";
import { useTranslation } from "react-i18next";

const DropZone = ({
  isDragActive,
  getRootProps,
  getInputProps,
  multipleFilesAllowed,
  maxFileSize,
  allowedFileTypes,
  hasFileSizeLimit,
}) => {
  const { t } = useTranslation();

  const shouldAllowSingleFileUpload = !multipleFilesAllowed;
  const shouldShowFileSizeLimit = hasFileSizeLimit && maxFileSize;

  return (
    <div
      {...getRootProps({
        className: classnames(["neeto-molecules-file-upload__dropzone"], {
          "neeto-molecules-file-upload__dropzone--drag-active": isDragActive,
        }),
      })}
    >
      <div
        className="neeto-molecules-file-upload__dropzone-inner"
        data-testid="file-upload-body"
      >
        <FileUpload
          className="neeto-molecules-file-upload__upload-icon"
          size="36"
        />
        <div className="neeto-molecules-file-upload__dropzone-content">
          <label
            className="neeto-molecules-file-upload__upload-label"
            htmlFor="file-upload"
          >
            <span className="neeto-molecules-file-upload__choose-file">
              {t(
                "neetoMolecules.fileUpload.filesDropzone.chooseFileOrDragHere"
              )}
            </span>
            <input {...getInputProps()} data-testid="image-browse-button" />
          </label>
          <div className="neeto-molecules-file-upload__dropzone-helper-block">
            {shouldAllowSingleFileUpload && (
              <p
                className="neeto-molecules-file-upload__dropzone-helper-text"
                data-testid="upload-only-one-file-text"
              >
                {t("neetoMolecules.fileUpload.filesDropzone.oneFileAllowed")}
              </p>
            )}
            {shouldShowFileSizeLimit && (
              <p
                className="neeto-molecules-file-upload__dropzone-helper-text"
                data-testid="maximum-allowed-size-text"
              >
                {t("neetoMolecules.fileUpload.filesDropzone.maxFileSize", {
                  size: maxFileSize,
                  unit: "MB",
                })}
              </p>
            )}
            {allowedFileTypes && (
              <p
                className="neeto-molecules-file-upload__dropzone-helper-text"
                data-testid="allowed-files-types-text"
              >
                {t("neetoMolecules.fileUpload.filesDropzone.allowedFileTypes", {
                  types: allowedFileTypes,
                })}
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DropZone;
